module.exports = __webpack_public_path__ + "static/media/rebirth_20.d7b6e326.jpg";